export default __webpack_public_path__ + "static/app-access-dark-f5ac29901ecba4359770991580f719da.png";